module.exports = __webpack_public_path__ + "static/yachtsafe-env2-1ac92291aa4aa2b4533cead936ee0e7e.jpg";